module.exports = __webpack_public_path__ + "img/test-blackboard.040b2158.png";